<h1 id="list-item-4">
    <marquee scrolldelay="80">
      <pre>رحلة أمل وألم      رحلة أمل وألم      رحلة أمل وألم      رحلة أمل وألم      رحلة أمل وألم      رحلة أمل وألم      رحلة أمل وألم      رحلة أمل وألم</pre>
    </marquee>
    <marquee direction="right" scrolldelay="80">
      <pre>رحلة أمل وألم      رحلة أمل وألم      رحلة أمل وألم      رحلة أمل وألم      رحلة أمل وألم      رحلة أمل وألم      رحلة أمل وألم      رحلة أمل وألم</pre>
    </marquee>
  </h1>
  <div class="Container">
    <img src="../../assets/photos/interview1.jpeg" class="image">
    <div class="text">
      <p>
        على الرغم من اختلاف حالات ابنتي .B.K و.J.G، إلا أن الكفاح يظل واحدًا.
        تدفع قساوة الحياة الأطفال ذوي الاحتياجات الخاصة للابتعاد عن محيطهم والتخلي عن براءتهم، إلا أنهم لا يرضخون.
        فقلوبهم لا تستسلم أبدًا بالرغم من الظلم المحيط بهم. فهم يسيرون في رحلتهم بإيجابية ويجتازون كل مرحلة من مراحل
        الحياة بإصرار وحب.
      </p>
      <p>
        في الغالب يحتاج الأطفال ذوو الاحتياجات الخاصة إلى رحلة علاج طويلة تتطلب مواكبة متخصصة ومساعدة يقدمها أهلهم وذويهم
        سواء في المنزل أو في المدرسة. وفقًا لمعالجة النطق نانسي شبيب، تعتبر علاجات التفاعل الاجتماعي والتواصل أمرًا حاسمًا
        لتقدم الطفل؛ لذلك، يشجعهم التواصل على التقدم في أي مهارة يفتقرون إليها". وبحسب وضع كل طفل، تختلف المسارات لكن
        تبدأ كلها بمرحلة التشخيص ومن ثم إقتراح العلاجات المناسبة للنهوض بالحالة.
      </p>
    </div>
  </div>
  
  <h1 id="list-item-5">
    <marquee scrolldelay="80">
      <pre>نتائج الجائحة      نتائج الجائحة      نتائج الجائحة      نتائج الجائحة      نتائج الجائحة      نتائج الجائحة      نتائج الجائحة      نتائج الجائحة</pre>
    </marquee>
    <marquee direction="right" scrolldelay="80">
      <pre>نتائج الجائحة      نتائج الجائحة      نتائج الجائحة      نتائج الجائحة      نتائج الجائحة      نتائج الجائحة      نتائج الجائحة      نتائج الجائحة</pre>
    </marquee>
  </h1>
  <div class="Container">
    <img src="../../assets/photos/interview2.jpeg" class="image">
    <div class="text">
      <p>
        مع ظهور جائحة COVID-19، تعطل مسار حياة هؤلاء الأطفال الذين يحتاجون إلى نظام وروتين. لقد أُجبروا على أخذ العلاج عبر
        الإنترنت والتعلم عن بعد، مما تسبب في تراجع مهاراتهم وكذلك صحتهم العقلية، إذ حد هذا النوع من التعلم من تحسنهم
        وتطورهم. وبحسب المعالجة النفسية، هالة معلوف "لم يمارس الأطفال ذوو الاحتياجات الخاصة أي نشاط بدني من أجل تحرير
        الطاقة المحتجزة بداخلهم، لقد كانوا مجرد متلقين يتلقفون المعلومات فقط". ومع ذلك، ترى شبيب أن هناك ميزة واحدة للعلاج
        عبر الإنترنت وهي وجود الوالدين إلى جانب أطفالهم. "كان الأهل يشاركون في الجلسات، إذ أنهم تعلموا كيفية القيام
        بالتمارين المناسبة لأطفالهم في المنزل. وقد ساعدنا هذا الأمر كثيرًا، لأن التقدم لم يكن يعتمد على العلاج وحده بل
        على دعم العائلة أيضًا". لذا يمكن القول أن العلاج عبر الانترنت كان الحل الأمثل خلال فترة الوباء لتعذر المواكبة
        وجهًا لوجه لأن هؤلاء الأطفال يحتاجون إلى التحفيز المستمر وتقييم تقدمهم.
      </p>
      <p>
        بالإضافة إلى ذلك، شددت كل من معلوف وشبيب على أهمية الشعور بالثقة بقدرات الأطفال. في هذا الاطار تعتبر المحللة
        النفسية راشيل علم أن "الافتقار إلى التفاعل الاجتماعي أثناء الوباء جعل هؤلاء الأطفال يشعرون وكأنهم لا يستطيعون
        التواصل والتعبير عن مشاعرهم لأي شخص".
      </p>
      <p>
        عندما تحسن الوضع، استؤنفت العلاجات مع اعتماد تدابير السلامة المناسبة، وبدأ الأطفال في بذل جهود إضافية لتحقيق
        التقدم المرجو، وتمكنوا من التعبير عن مشاعرهم بحرية إما من خلال الكلمات أو من خلال التعبير الجسدي. وبحسب شبيب،
        "العلاجات لم تعد عبر شاشة الكمبيوتر، بل أصبحت تتتم بين شخصين يتواصلان، ويركزان على المشاعر والأحاسيس". بالإضافة
        إلى ذلك، عاد بعد ذلك الأطفال ذوو الاحتياجات الخاصة إلى المدرسة مما ساعدهم على استعادة بعض ما فاتهم بالتأكيد.
      </p>
    </div>
  </div>
  
  <h1 id="list-item-6">
    <marquee scrolldelay="80">
      <pre>الانهيار الاقتصادي وأثره المدمِّر على هؤلاء الأطفال الأبطال      الانهيار الاقتصادي وأثره المدمِّر على هؤلاء الأطفال الأبطال      الانهيار الاقتصادي وأثره المدمِّر على هؤلاء الأطفال الأبطال</pre>
    </marquee>
    <marquee direction="right" scrolldelay="80">
      <pre>الانهيار الاقتصادي وأثره المدمِّر على هؤلاء الأطفال الأبطال      الانهيار الاقتصادي وأثره المدمِّر على هؤلاء الأطفال الأبطال      الانهيار الاقتصادي وأثره المدمِّر على هؤلاء الأطفال الأبطال</pre>
    </marquee>
  </h1>
  <div class="Container">
    <img src="../../assets/photos/interview3.jpeg" class="image">
    <div class="text">
      <p>
        لا يمكن التغاضي عن أثر الانهيار الاقتصادي في لبنان وتزامنه مع جائحة كورونا. حيث اضطرت العديد من المدارس المتخصصة
        إلى إغلاق أبوابها بسبب انهيار العملة، ولم يعد بمقدور الكثير من الأهل تحمّل تكاليف علاج أطفالهم. فأصبح من الصعب
        العثور على المؤسسات المناسبة بسبب الأزمة الصحية والاقتصادية. وحتى إن توفرت أماكن محدودة في هذه المؤسسات فتبقى
        التكاليف باهظة جدًا بالنسبة لشريحة كبيرة من اللبنانيين. تقول الوالدة B.K إن مدرسة ابنتها اضطرت إلى فتح أبوابها
        ثلاثة من أصل خمسة أيام في الأسبوع بسبب الوضع الاقتصادي. تذهب ابنتها إلى المدرسة أيام الثلاثاء والأربعاء والخميس
        فقط في الوقت الحالي، وقد أدى هذا إلى تباطؤ تقدمها.
      </p>
      <p>
        أثرت الأزمة الاقتصادية على استمرار العلاجات، فقد ذكرت المعالجتان معلوف وشبيب أنه إذا توقف الأهل عن العلاج
        لأطفالهم، فقد ينعكس ذلك سلبًا عليهم، ومن ثم يؤثر على الأسرة ككل. وذكرتا أن الطفل ذا الاحتياجات الخاصة يحتاج إلى
        الرعاية المستمرة ويمكن أن يؤدي أي تغيير طفيف إلى تباطؤ التقدم.
      </p>
      <p>
        في مقابلة مع السيدة لمى بدوي، مديرة ال Ideal Program-NDU، إعتبرت بدوي أن الأثر الكبير الذي أحدثه الوباء على الطلاب ذوي
        الاحتياجات الخاصة، كان هائلاً، ولكنها أوضحت أن هناك العديد من البدائل المجانية وأسعار مخفضة للعلاج. ولكن المشكلة
        الوحيدة هي أن قائمة الانتظار لأخذ العلاجات المجانية طويلة جدًا".
      </p>
    </div>
  </div>
  
  <h1 id="list-item-7">
    <marquee scrolldelay="80">
      <pre>الأهل في الصفوف الأمامية للمواجهة      الأهل في الصفوف الأمامية للمواجهة      الأهل في الصفوف الأمامية للمواجهة</pre>
    </marquee>
    <marquee direction="right" scrolldelay="80">
      <pre>الأهل في الصفوف الأمامية للمواجهة      الأهل في الصفوف الأمامية للمواجهة      الأهل في الصفوف الأمامية للمواجهة</pre>
    </marquee>
  </h1>
  <div class="Container">
    <img src="../../assets/photos/interview4.jpeg" class="image">
    <div class="text">
      <p>
        غالبًا ما يتم ايلاء الطفل ذي الاحتياجات الخاصة الاهتمام، ولكن يتم تجاهل الصعوبات التي تواجهها أسر هؤلاء الأطفال في
        الكثير من الأحيان. بعد إجراء مقابلات مع العديد من الأهل، اتضح جليًا أن الانكماش الاقتصادي والوباء وضعا جميع الأهل
        تحت الضغط دون أدنى شك.
      </p>
    </div>
  </div>
  
  <h1 id="list-item-8">
    <marquee scrolldelay="80">
      <pre>الحلول الممكنة لمساعدة ذوي الاحتياجات الخاصة في ظل الانهيار الحاصل      الحلول الممكنة لمساعدة ذوي الاحتياجات الخاصة في ظل الانهيار الحاصل      الحلول الممكنة لمساعدة ذوي الاحتياجات الخاصة في ظل الانهيار الحاصل</pre>
    </marquee>
    <marquee direction="right" scrolldelay="80">
      <pre>الحلول الممكنة لمساعدة ذوي الاحتياجات الخاصة في ظل الانهيار الحاصل      الحلول الممكنة لمساعدة ذوي الاحتياجات الخاصة في ظل الانهيار الحاصل      الحلول الممكنة لمساعدة ذوي الاحتياجات الخاصة في ظل الانهيار الحاصل</pre>
    </marquee>
  </h1>
  <div class="Container">
    <img src="../../assets/photos/interview5.jpeg" class="image">
    <div class="text">
      <p>
        ترك الوباء والتدهور الإقتصادي أثراً كبيراً على الأهل والأطفال على حد سواء، لكن يبقى الأمل هو الأساس. تعطي معلوف
        الحل قائلة" يجب دائمًا على الأهل مراعاة متطلبات أطفالهم وعدم التوقف عن العلاج لأي سبب من الأسباب. يمكن دائمًا
        التوصل إلى حل". و يتقاطع هذا الرأي مع ما عبرت عنه لمى بدوي مديرة برنامج IDEAL الذي أتينا على ذكره والمعالجة
        النفسية راشيل علم ضمن البرنامج نفسه "يحتاج ذوو الاحتياجات الخاصة إلى نظام واستقرار في حياتهم. لذلك، يجب المواظبة
        على الدروس كي لا تضيع جهودهم".
      </p>
      <p>
        كما ذكرنا سابقًا، هناك العديد من المنظمات غير الحكومية والمعالجين المستقلين الذين يقدمون علاجات بأسعار مخفضة أو
        مجانية، ولكن تبقى هذه المبادرات فردية. ومع الأسف، فالحكومة لا تبذل أي جهدٍ حقيقي للمساعدة والنهوض بحالة هؤلاء
        الأطفال.
      </p>
      <p>
        يحتاج الأطفال ذوو الاحتياجات الخاصة إلى تفاعل اجتماعي وتحفيز مستمر بالإضافة إلى تقييم متواصل. لهذا السبب، أثرت
        جائحة Covid-19 بشكل كبير على مساراتهم، كما أثرت عليهم القيود المفروضة من جراء الاقفال العام والأزمات المتراكمة
        التي يعاني منها لبنان. ومع ذلك، فقد كان تعاضد الاهل والمعالجين النقسيين بمثابة حجر الأساس في الحد من الآثار
        السلبية.
      </p>
      <p id="list-item-9" class="lastParagraph">
        خاض الأطفال ذوو الاحتياجات الخاصة كل تلك المعارك التي أتينا على ذكرها بمساعدة عائلاتهم والكوادر العلاجية وسط صمت
        وغياب مطلق للدولة ومؤسساتها المهنية. فأين هي الطبقة الحاكمة من كل ذلك؟
      </p>
    </div>
  </div>